export const SET_LOCAL = 'SET_LOCAL'

export const setLocal = (local) => {
    return {
        type: SET_LOCAL,
        payload: local
    }
}

